import FetchService from "@core-ui/ApiServices/FetchService";
import ApiUrlCreatorService from "@core-ui/ContextServices/ApiUrlCreator";
import AgentSkillService from "@ext/agent/components/skills/AgentSkillService";
import type { UserAgentSkill } from "@ext/agent/core/agentResourcesProvider";
import t from "@ext/localization/locale/translate";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@ui-kit/Dropdown";
import { Icon } from "@ui-kit/Icon";
import { MenuItemIconButton } from "@ui-kit/MenuItem";
import { useState } from "react";

type ChatSkillActionsProps = {
	skill: UserAgentSkill;
	onClose: () => void;
	onDeleted: (skill: UserAgentSkill) => void;
};

export const ChatSkillActions = ({ skill, onClose, onDeleted }: ChatSkillActionsProps) => {
	const apiUrlCreator = ApiUrlCreatorService.value;
	const { selectedID } = AgentSkillService.value;
	const [open, setOpen] = useState(false);

	const editSkill = () => {
		AgentSkillService.openItem({ id: skill.id, title: skill.name });
		onClose();
	};

	const deleteSkill = async () => {
		if (!(await confirm(t("confirm-agent-skills-delete")))) return;
		const response = await FetchService.fetch(apiUrlCreator.removeFileInGramaxDir(skill.id, "agentSkill"));
		if (!response.ok) return;
		if (selectedID === skill.id) AgentSkillService.closeItem();
		onDeleted(skill);
	};

	return (
		<DropdownMenu onOpenChange={setOpen} open={open}>
			<DropdownMenuTrigger asChild>
				<MenuItemIconButton
					aria-label={t("actions")}
					className="size-5 p-1"
					icon="ellipsis"
					onClick={(event) => {
						event.stopPropagation();
						setOpen(true);
					}}
				/>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" onClick={(event) => event.stopPropagation()}>
				<DropdownMenuItem
					onSelect={(event) => {
						event.preventDefault();
						event.stopPropagation();
						setOpen(false);
						editSkill();
					}}
				>
					<Icon icon="pencil" />
					{t("agent.skills.edit-skill")}
				</DropdownMenuItem>
				<DropdownMenuItem
					onSelect={(event) => {
						event.preventDefault();
						event.stopPropagation();
						setOpen(false);
						void deleteSkill();
					}}
					type="danger"
				>
					<Icon icon="trash-2" />
					{t("delete")}
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};
